/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '../../node_modules/ng2-slim-loading-bar/src/slim-loading-bar.component.ngfactory';
import * as i2 from 'ng2-slim-loading-bar/src/slim-loading-bar.component';
import * as i3 from 'ng2-slim-loading-bar/src/slim-loading-bar.service';
import * as i4 from '@angular/router';
import * as i5 from '../../../src/app/app.component';
import * as i6 from '@ngx-translate/core/src/translate.service';
import * as i7 from '../../../src/app/mixpanel/mixpanel.service';
import * as i8 from '../../../src/app/localstorage.service';
import * as i9 from '../../../src/app/order/order.service';
import * as i10 from '../../../src/app/order/currentOrder.service';
var styles_AppComponent = [];
export var RenderType_AppComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_AppComponent,
    data: {} });
export function View_AppComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'ng2-slim-loading-bar', [['color', '#0094d4'], ['height', '3px']], null, null, null, i1.View_SlimLoadingBarComponent_0, i1.RenderType_SlimLoadingBarComponent)), i0.ɵdid(114688, null, 0, i2.SlimLoadingBarComponent, [i3.SlimLoadingBarService], { color: [0,
                'color'], height: [1, 'height'] }, null), (_l()(), i0.ɵeld(16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)), i0.ɵdid(212992, null, 0, i4.RouterOutlet, [i4.ChildrenOutletContexts, i0.ViewContainerRef, i0.ComponentFactoryResolver, [8,
                null], i0.ChangeDetectorRef], null, null)], function (_ck, _v) {
        var currVal_0 = '#0094d4';
        var currVal_1 = '3px';
        _ck(_v, 1, 0, currVal_0, currVal_1);
        _ck(_v, 3, 0);
    }, null);
}
export function View_AppComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'cx-app', [], null, null, null, View_AppComponent_0, RenderType_AppComponent)),
        i0.ɵdid(4308992, null, 0, i5.AppComponent, [i4.Router, i3.SlimLoadingBarService,
            i6.TranslateService, i7.MixpanelService, i8.LocalStorageService, i9.OrderService,
            i10.CurrentOrderService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var AppComponentNgFactory = i0.ɵccf('cx-app', i5.AppComponent, View_AppComponent_Host_0, {}, {}, []);
//# sourceMappingURL=app.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/app.component.ngfactory.js
// module id = 1201
// module chunks = 0